import React from 'react';

export function HomePage() {
  return (
    <div>
      <p>You are logged in</p>
    </div>
  );
}
